//Please add the language resource
const box = {
  creator:'Creator',
  recycleBoxNo:'BoxCode',
  createTime:'CreateTime',
  warehouseCode:'WareHouse',
  msg:{
  }
};
export default box



// WEBPACK FOOTER //
// ./src/page/md/box/lang/mdBox.en.js